import "./ErrorContainer.scss";
import type { AppError } from "../../store/app/types"
import { Icon, Markdown } from "../../viewer/components";
import { NavBar } from "../components";

export type ErrorContainerProps = {
    error?: AppError;
    includeNavBar?: boolean;
    children?: React.ReactNode;
}

export function ErrorContainer(props: ErrorContainerProps) {
    const { error, includeNavBar, children } = props;

    if (!error) {
        return <>{children}</>;
    }

    return (
        includeNavBar ?
        <div className="col-fill">
            <NavBar title="Failed to load" />
            <ERROR_CONTAINER error={error} />
        </div> :
        <ERROR_CONTAINER error={error} />
    );
}

const ICONS = {
    "NotFound": "search_off",
    "Connectivity": "cloud_off",
    "Maintenance": "build_circle",
    "Generic": "error"
};

function ERROR_CONTAINER(props: ErrorContainerProps) {
    const { error } = props;
    const { type, message, details } = error;
    const icon = ICONS[type] ?? "error";

    return (
        <div className="error-page">
            <div className="error-container">
                <div className="image">
                    <Icon>{icon}</Icon>
                </div>
                <div className="heading">
                    {message}
                </div>
                <div className="details">
                    <Markdown children={details} />
                </div>
            </div>
        </div>
    );
}